import { fetchUserAttributes } from '@aws-amplify/auth';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useQuery } from 'react-query';

const useUserAttributes = () => {
  const { authStatus } = useAuthenticator((c) => [c.authStatus]);

  // TODO: export refetch after update

  const { data: userAttributes, isLoading } = useQuery({
    queryKey: ['userAttributes'],
    queryFn: () => fetchUserAttributes(),
    enabled: authStatus === 'authenticated',
  });

  return { userAttributes, isLoading };
};

export default useUserAttributes;
